import { cn } from '@nexelem/utils';
import { PropsWithChildren } from 'react';

type DrawerContentProps = {
  className?: string;
};

export const DrawerContent = ({ children, className }: PropsWithChildren<DrawerContentProps>) => (
  <div className={cn('grow overflow-auto p-6', className)}>{children}</div>
);
